import React, { useState, useEffect } from 'react';
import {
  Card, Tabs, Descriptions, Tag, Button, Input, Select, message,
  Spin, Image, Typography, Table, Alert
} from 'antd';
import {
  CheckCircleOutlined, WarningOutlined, CloseCircleOutlined,
  EditOutlined, CheckOutlined
} from '@ant-design/icons';
import { countConfiguredFees } from '../../../utils/paymentChannels';
import { MOCK_SERVICE_TYPES, REGION_LABEL } from '../BusinessConfig/serviceTypes';

const { Text } = Typography;

// ══════════════════════════════════════════
//  Mock 数据
// ══════════════════════════════════════════

// TODO: 联调时替换为接口数据
const SCALE_OPTIONS = ['1-50人', '51-200人', '201-500人', '500人以上'];

const MOCK_COMPANY_DATA = {
  companyId: 'CV3YyaGN8Y1xKFqk',
  name: '鹤梦云生态科技有限公司',
  creditCode: '91320000MA1EXAMPLE',
  legalRepresentative: '张三',
  registerTime: 1735747200,
  address: '江苏省南京市建邺区XX路88号',
  registerPhone: '18115178069',
  contactPerson: '李四',
  contactPosition: '技术总监',
  contactPhone: '18115178069',
  contactEmail: 'contact@hemeng.com',
  scale: '51-200人',
  status: 2, // 0=未认证 1=待审核 2=已认证 3=已拒绝
  licenseAttachment: '',
  description: '鹤梦云生态平台是面向物联网行业的云生态服务平台，提供产品研发、设备管理、数据运营、收益分润等一站式服务。',
  licenseDiscount: 80,
  // 三块场景各自的底价配置（国内/海外默认 + 服务类型覆盖）
  giftBasePrice: {
    default: {
      cn: { isDeductBasePrice: true, discountRatio: 80.00, remark: '年度战略合作协议约定八折' },
      os: { isDeductBasePrice: true, discountRatio: 100.00, remark: '' },
    },
    services: {
      '300010': {
        cn: { isDeductBasePrice: true, discountRatio: 100.00 },
        os: { isDeductBasePrice: false, discountRatio: 100.00 },
      },
    },
  },
  selfBasePrice: {
    default: {
      cn: { isDeductBasePrice: true, discountRatio: 80.00, remark: '年度战略合作协议约定八折' },
      os: { isDeductBasePrice: false, discountRatio: 100.00, remark: '海外暂不扣底价' },
    },
    services: {
      '300033': {
        cn: { isDeductBasePrice: true, discountRatio: 90.00 },
        os: { isDeductBasePrice: true, discountRatio: 100.00 },
      },
    },
  },
  selfCommission: {
    cn: { isCommission: true, commissionRate: 10.00, isCommissionDeductBasePrice: true },
    os: { isCommission: false, commissionRate: 10.00, isCommissionDeductBasePrice: true },
    isDeductPaymentFee: true,
    paymentFees: {
      wechat: { rate: 0.60, fixedFeeCny: 0.30 },
      alipay: { rate: 1.50, fixedFeeCny: 0.90 },
    },
  },
  platformCommission: {
    cn: { isCommission: true, commissionRate: 12.00, isCommissionDeductBasePrice: true },
    os: { isCommission: true, commissionRate: 8.00, isCommissionDeductBasePrice: false },
    isDeductPaymentFee: false,
    paymentFees: {},
  },
  trafficGroup: {
    name: '标准价',
    cnyPrice: 0.80,
    usdPrice: 0.12,
    exchangeRate: 7.20,
    countryPrices: [{ country: '美国', usdPrice: 0.10 }, { country: '日本', usdPrice: 0.08 }]
  },
  adCommissionApps: [
    {
      key: 'HS_iOS_CN', appId: 'HS_iOS_CN', appName: 'HomeStar', system: 'iOS', region: '国内',
      configs: [
        { key: 'c1', adSource: 1, adPlatform: 'max', rate: 15.00 },
        { key: 'c2', adSource: 1, adPlatform: 'fengchuan', rate: 10.00 },
      ],
    },
    { key: 'HS_AND_CN', appId: 'HS_AND_CN', appName: 'HomeStar', system: 'Android', region: '国内', configs: [] },
    { key: 'PL_IOS_OS', appId: 'PL_IOS_OS', appName: 'ParkingCloud', system: 'iOS', region: '海外', configs: [] },
  ]
};

const fmtUnix = (ts) => {
  if (!ts) return '';
  return new Date(ts * 1000).toLocaleString('zh-CN', { hour12: false });
};
const fmtPercent = (val) => {
  if (val === undefined || val === null) return '100.00%';
  return Number(val).toFixed(2) + '%';
};

// ══════════════════════════════════════════
//  状态横幅
// ══════════════════════════════════════════

const StatusBanner = ({ status, registerTime }) => {
  if (status === 2) {
    return (
      <div style={{ padding: '16px 24px', borderRadius: 8, background: '#2db87a', color: '#fff' }}>
        <div style={{ fontSize: 16, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
          <CheckCircleOutlined style={{ fontSize: 22 }} />
          企业认证已完成！
          <Tag style={{ background: 'rgba(255,255,255,0.25)', border: '1px solid rgba(255,255,255,0.4)', color: '#fff', marginLeft: 4 }}>已认证</Tag>
        </div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginTop: 6 }}>您已享受平台全部企业权益！</div>
        <Tag style={{ marginTop: 8, background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.35)', color: '#fff' }} round>
          认证时间：{fmtUnix(registerTime)}
        </Tag>
      </div>
    );
  }
  if (status === 1) {
    return (
      <div style={{ padding: '16px 24px', borderRadius: 8, background: '#e6a23c', color: '#fff' }}>
        <div style={{ fontSize: 16, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
          <WarningOutlined style={{ fontSize: 22 }} />
          企业认证审核中
          <Tag color="warning" style={{ marginLeft: 4 }}>待审核</Tag>
        </div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginTop: 6 }}>您的企业认证信息正在审核中，请耐心等待。</div>
      </div>
    );
  }
  return (
    <div style={{ padding: '16px 24px', borderRadius: 8, background: '#f56c6c', color: '#fff' }}>
      <div style={{ fontSize: 16, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
        <CloseCircleOutlined style={{ fontSize: 22 }} />
        企业认证被拒绝
        <Tag color="error" style={{ marginLeft: 4 }}>已拒绝</Tag>
      </div>
      <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginTop: 6 }}>请修改认证信息后重新提交。</div>
    </div>
  );
};

// ══════════════════════════════════════════
//  企业信息与联系方式
// ══════════════════════════════════════════

const CompanyContact = ({ companyData, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({});

  const fields = [
    { label: '企业名称', field: 'name', editable: false, render: (d) => `${d.name || '--'}（${d.companyId || ''}）` },
    { label: '统一社会信用代码', field: 'creditCode', editable: false },
    { label: '法定代表人', field: 'legalRepresentative', editable: false },
    { label: '注册时间', field: 'registerTime', editable: false, render: (d) => fmtUnix(d.registerTime) || '--' },
    { label: '公司地址', field: 'address', editable: false, span: 2 },
    { label: '注册手机号', field: 'registerPhone', editable: false },
    { label: '联系人', field: 'contactPerson', editable: true },
    { label: '联系人职务', field: 'contactPosition', editable: true },
    { label: '联系人号码', field: 'contactPhone', editable: true },
    { label: '联系邮箱', field: 'contactEmail', editable: true },
    { label: '公司规模', field: 'scale', editable: true, type: 'select', options: SCALE_OPTIONS },
  ];

  const syncFormData = () => {
    const data = {};
    fields.forEach(item => {
      if (item.editable) data[item.field] = companyData[item.field] || '';
    });
    setFormData(data);
  };

  const handleBlur = (field) => {
    const newVal = formData[field];
    const oldVal = companyData[field] || '';
    if (newVal === oldVal) return;
    // TODO: 联调时替换为接口数据
    message.success('更新成功');
    onUpdate({ [field]: newVal });
  };

  const items = fields.map(item => ({
    key: item.field,
    label: item.label,
    span: item.span || 1,
    children: (
      <div style={{ minHeight: 24, display: 'flex', alignItems: 'center' }}>
        {editing && item.editable ? (
          item.type === 'select' ? (
            <Select
              value={formData[item.field]}
              placeholder={'请选择' + item.label}
              size="small"
              style={{ width: '100%' }}
              onChange={(v) => { setFormData(prev => ({ ...prev, [item.field]: v })); handleBlur(item.field); }}
              options={SCALE_OPTIONS.map(o => ({ value: o, label: o }))}
            />
          ) : (
            <Input
              value={formData[item.field]}
              placeholder={'请输入' + item.label}
              size="small"
              style={{ width: '100%' }}
              onChange={(e) => setFormData(prev => ({ ...prev, [item.field]: e.target.value }))}
              onBlur={() => handleBlur(item.field)}
            />
          )
        ) : (
          <span>{item.render ? item.render(companyData) : (companyData[item.field] || '--')}</span>
        )}
      </div>
    )
  }));

  return (
    <div style={{ padding: '20px 0', borderBottom: '1px solid #ebeef5' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#303133' }}>企业信息与联系方式</span>
        {!editing ? (
          <Button type="link" icon={<EditOutlined />} onClick={() => { syncFormData(); setEditing(true); }}>编辑</Button>
        ) : (
          <Button type="link" icon={<CheckOutlined />} onClick={() => setEditing(false)}>完成</Button>
        )}
      </div>
      <Descriptions column={3} items={items} size="middle" />
    </div>
  );
};

// ══════════════════════════════════════════
//  企业介绍
// ══════════════════════════════════════════

const CompanyDescription = ({ companyData, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [descValue, setDescValue] = useState('');

  const handleBlur = () => {
    const newVal = descValue;
    const oldVal = companyData.description || '';
    if (newVal === oldVal) return;
    // TODO: 联调时替换为接口数据
    message.success('企业介绍更新成功');
    onUpdate({ description: newVal });
  };

  return (
    <div style={{ padding: '20px 0' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#303133' }}>企业介绍</span>
        {!editing ? (
          <Button type="link" icon={<EditOutlined />} onClick={() => { setDescValue(companyData.description || ''); setEditing(true); }}>编辑</Button>
        ) : (
          <Button type="link" icon={<CheckOutlined />} onClick={() => setEditing(false)}>完成</Button>
        )}
      </div>
      {editing ? (
        <Input.TextArea
          value={descValue}
          rows={5}
          placeholder="请输入企业介绍"
          onChange={(e) => setDescValue(e.target.value)}
          onBlur={handleBlur}
        />
      ) : (
        <div style={{ fontSize: 14, color: '#606266', lineHeight: 1.8 }}>{companyData.description || '暂无介绍'}</div>
      )}
    </div>
  );
};

// ══════════════════════════════════════════
//  企业信息 Tab（企业信息与联系方式 + 资质证明 + 企业介绍）
// ══════════════════════════════════════════

const CompanyInfoDetail = ({ companyData, onUpdate }) => (
  <div>
    <Card size="small" style={{ marginBottom: 12 }}>
      <CompanyContact companyData={companyData} onUpdate={onUpdate} />
    </Card>

    <Card size="small" style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#303133' }}>资质证明</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 24 }}>
        {companyData.licenseAttachment && (
          <div style={{ flexShrink: 0, textAlign: 'center', border: '1px solid #e4e7ed', borderRadius: 8, padding: 12, background: '#fff' }}>
            <Image
              src={companyData.licenseAttachment}
              preview={{ src: companyData.licenseAttachment }}
              style={{ width: 100, height: 100, borderRadius: 6, objectFit: 'cover' }}
            />
            <div style={{ fontSize: 13, color: '#606266', marginTop: 8 }}>营业执照</div>
          </div>
        )}
        <span style={{ fontSize: 13, color: '#909399', lineHeight: 1.6 }}>营业执照信息已通过审核，如需更换请联系平台客服进行更新审核。</span>
      </div>
    </Card>

    <Card size="small">
      <CompanyDescription companyData={companyData} onUpdate={onUpdate} />
    </Card>
  </div>
);

// ══════════════════════════════════════════
//  商务信息 Tab（只读：License折扣 + 企业自收款 + 平台代收款）
// ══════════════════════════════════════════

const BizSection = ({ title, children }) => (
  <div style={{ padding: '20px 0', borderBottom: '1px solid #ebeef5' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
      <span style={{ fontSize: 15, fontWeight: 600, color: '#303133' }}>{title}</span>
    </div>
    {children}
  </div>
);

const BizStatus = ({ on, onText, offText }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 500, color: on ? '#67c23a' : '#c0c4cc' }}>
    <span style={{ width: 8, height: 8, borderRadius: '50%', background: on ? '#67c23a' : '#c0c4cc', boxShadow: on ? '0 0 0 2px rgba(103,194,58,0.2)' : 'none' }} />
    {on ? onText : offText}
  </span>
);

const BizBaseCard = ({ policy, deductionHint, showRemark = true, title = '区域默认策略', extra = null }) => (
  <div style={{ background: '#f7f8fa', borderRadius: 8, padding: '14px 20px', marginBottom: 12 }}>
    <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px', flexWrap: 'wrap' }}>
      <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>{title}</span>
      <BizStatus on={policy.isDeductBasePrice} onText="扣除" offText="不扣除" />
      {policy.isDeductBasePrice && (
        <span style={{ color: '#303133', fontSize: 14, fontWeight: 500, marginLeft: 12 }}>
          {fmtPercent(policy.discountRatio)}
        </span>
      )}
      <span style={{ color: '#b0b3bb', fontSize: 12, marginLeft: 10 }}>{deductionHint}</span>
    </div>
    {showRemark && policy.remark && (
      <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px' }}>
        <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>备注</span>
        <span style={{ color: '#303133', fontSize: 14 }}>{policy.remark}</span>
      </div>
    )}
    {extra}
  </div>
);

const BizServiceOverrideTable = ({ overrides, fallback }) => {
  const rows = Object.entries(overrides || {}).map(([serviceId, policy]) => {
    const st = MOCK_SERVICE_TYPES.find((s) => s.serviceId === serviceId);
    return {
      serviceId,
      serviceName: st ? st.serviceName : serviceId,
      categoryName: st ? st.categoryName || '未分类' : '未分类',
      cn: policy?.cn || fallback?.cn,
      os: policy?.os || fallback?.os,
    };
  });
  if (!rows.length) {
    return (
      <div style={{ color: '#b0b3bb', fontSize: 12, padding: '4px 0 8px' }}>
        未单独配置服务类型，全部服务类型按该场景默认策略生效
      </div>
    );
  }
  const policyCell = (policy) => (
    <div>
      <BizStatus on={policy?.isDeductBasePrice} onText="扣除" offText="不扣除" />
      {policy?.isDeductBasePrice && (
        <span style={{ color: '#303133', fontSize: 13, marginLeft: 8 }}>{fmtPercent(policy.discountRatio)}</span>
      )}
    </div>
  );
  return (
    <div style={{ marginTop: 4 }}>
      <div style={{ fontSize: 13, color: '#606266', marginBottom: 8 }}>服务类型单独配置（仅展示已配置项）</div>
      <Table
        rowKey="serviceId"
        size="small"
        bordered
        pagination={false}
        dataSource={rows}
        columns={[
          { title: '服务分类', dataIndex: 'categoryName', key: 'category', width: 110 },
          {
            title: '服务类型', key: 'service', width: 200,
            render: (_, r) => (
              <div style={{ paddingLeft: 12 }}>
                <div style={{ fontWeight: 500 }}>{r.serviceName}</div>
                <span style={{ fontSize: 12, color: '#b0b3bb', fontFamily: 'monospace' }}>{r.serviceId}</span>
              </div>
            ),
          },
          { title: '国内（CNY）', key: 'cn', width: 190, render: (_, r) => policyCell(r.cn) },
          { title: '海外（USD）', key: 'os', width: 190, render: (_, r) => policyCell(r.os) },
        ]}
      />
    </div>
  );
};

const TrafficBizSection = ({ trafficGroup }) => (
  <div style={{ background: '#f7f8fa', borderRadius: 8, padding: '16px 20px' }}>
    {trafficGroup ? (
      <>
        <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px' }}>
          <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>收费规则</span>
          <span style={{ color: '#303133', fontSize: 14, fontWeight: 500 }}>{trafficGroup.name}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px' }}>
          <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>国内单价</span>
          <span style={{ color: '#303133', fontSize: 14, fontWeight: 500 }}>¥ {trafficGroup.cnyPrice.toFixed(2)} /G</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px' }}>
          <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>海外默认单价</span>
          <span style={{ color: '#303133', fontSize: 14, fontWeight: 500 }}>$ {trafficGroup.usdPrice.toFixed(2)} /G</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px' }}>
          <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>汇率（USD→CNY）</span>
          <span style={{ color: '#303133', fontSize: 14, fontWeight: 500 }}>{trafficGroup.exchangeRate.toFixed(2)}</span>
        </div>
        {trafficGroup.countryPrices?.length > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px' }}>
            <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>国家精细价</span>
            <span style={{ color: '#303133', fontSize: 14 }}>
              {trafficGroup.countryPrices.map(c => `${c.country} $${c.usdPrice.toFixed(2)}/G`).join('、')}
            </span>
          </div>
        )}
      </>
    ) : (
      <div style={{ color: '#909399', fontSize: 14 }}>未关联收费规则，暂不产生设备流量扣费</div>
    )}
  </div>
);

const AdCommissionBizSection = ({ apps }) => {
  const AD_SOURCE_LABEL = { 1: '企业广告源', 2: '平台广告源' };
  const AD_SOURCE_COLOR = { 1: 'orange', 2: 'red' };
  const appColumns = [
    {
      title: '应用（App-系统-区域）', key: 'app', width: 240,
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500 }}>{r.appName}-{r.system}-{r.region}</div>
          <span style={{ fontSize: 12, color: '#b0b3bb', fontFamily: 'monospace' }}>{r.appId}</span>
        </div>
      ),
    },
    {
      title: '已配置平台', key: 'count', width: 120, align: 'center',
      render: (_, r) => (r.configs?.length ? `${r.configs.length} 个` : <Text type="secondary">未配置</Text>),
    },
  ];
  const configColumns = [
    { title: '广告源', dataIndex: 'adSource', key: 'adSource', width: 130, render: (v) => <Tag color={AD_SOURCE_COLOR[v]}>{AD_SOURCE_LABEL[v] || '-'}</Tag> },
    { title: '广告平台', dataIndex: 'adPlatform', key: 'adPlatform', width: 140, render: (v) => <Tag color="geekblue" style={{ border: 'none' }}>{v}</Tag> },
    {
      title: '抽佣比例', key: 'rate', width: 120, align: 'right',
      render: (_, r) => (r.rate == null ? <Text type="secondary">不抽佣</Text> : `${Number(r.rate).toFixed(2)}%`),
    },
  ];

  return (
    <div>
      <Alert
        type="info" showIcon style={{ marginBottom: 8 }}
        message="企业广告源"
        description="App 广告收入由企业自行在广告平台结算，资金不经过平台。平台拉取广告收益账单后按月按抽佣比例出账，平台账务确认后从企业《消费账户》扣除平台广告抽佣。"
      />
      <Alert
        type="success" showIcon style={{ marginBottom: 12 }}
        message="平台广告源"
        description="App 广告收入直接结算至平台账户。扣除抽佣后的净额入企业《收益账户》，企业可发起提现。"
      />
      <Table
        rowKey="key"
        columns={appColumns}
        dataSource={apps || []}
        pagination={false}
        size="small"
        bordered
        expandable={{
          expandedRowRender: (record) => (
            <Table
              rowKey="key"
              size="small"
              columns={configColumns}
              dataSource={record.configs || []}
              pagination={false}
              locale={{ emptyText: '该 AppID 未配置广告抽佣' }}
            />
          ),
        }}
      />
    </div>
  );
};

const BusinessInfo = ({ companyData }) => (
  <div>
    <BizSection title="License折扣">
      <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0' }}>
        <span style={{ color: '#909399', fontSize: 14, minWidth: 90 }}>折扣比例</span>
        <span style={{ color: '#303133', fontSize: 14 }}>{companyData.licenseDiscount ?? '--'}%</span>
      </div>
    </BizSection>

    <BizSection title="设备流量商务">
      <TrafficBizSection trafficGroup={companyData.trafficGroup} />
    </BizSection>
  </div>
);

const PriceCommissionInfo = ({ companyData }) => {
  const giftConfig = companyData.giftBasePrice || { default: { cn: {}, os: {} }, services: {} };
  const selfConfig = companyData.selfBasePrice || { default: { cn: {}, os: {} }, services: {} };
  const selfComm = companyData.selfCommission || {};
  const platformComm = companyData.platformCommission || {};

  const renderDefaultCards = (config, comm, isPlatform) => (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: comm ? 8 : 12 }}>
        {['cn', 'os'].map((region) => {
          const regionComm = comm?.[region] || {};
          return (
            <BizBaseCard
              key={region}
              policy={config.default?.[region] || {}}
              deductionHint={region === 'cn' ? '企业《消费账户》实时扣除' : '按 USD 底价计算'}
              showRemark={false}
              title={`${REGION_LABEL[region]}默认策略`}
              extra={comm ? (
                <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', lineHeight: '28px', flexWrap: 'wrap' }}>
                  <span style={{ color: '#909399', fontSize: 14, minWidth: 110, flexShrink: 0 }}>抽佣</span>
                  {regionComm.isCommission ? (
                    <>
                      <span style={{ color: '#409eff', fontWeight: 600 }}>抽佣 {Number(regionComm.commissionRate).toFixed(2)}%</span>
                      <span style={{ color: '#b0b3bb', fontSize: 12, marginLeft: 10 }}>
                        抽佣扣底价：{regionComm.isCommissionDeductBasePrice ? '扣除' : '不扣除'}
                      </span>
                    </>
                  ) : <span style={{ color: '#c0c4cc' }}>不抽佣</span>}
                </div>
              ) : null}
            />
          );
        })}
      </div>
      {comm && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 14px', background: '#f7f8fa', border: '1px dashed #e4e7ed', borderRadius: 8, marginBottom: 12 }}>
          <span style={{ color: '#909399', fontSize: 13 }}>手续费</span>
          <BizStatus on={comm.isDeductPaymentFee} onText="扣除" offText="不扣除" />
          <span style={{ color: '#b0b3bb', fontSize: 12 }}>
            {comm.isDeductPaymentFee ? `${countConfiguredFees(comm.paymentFees)} 个支付方式已配置` : '按订单实付计算抽佣基数'}（不区分国内 / 海外）
          </span>
        </div>
      )}
    </>
  );

  return (
    <div>
      <BizSection title="企业赠送套餐 — 扣除底价配置">
        {renderDefaultCards(giftConfig)}
        <BizServiceOverrideTable overrides={giftConfig.services} fallback={giftConfig.default} />
        <div style={{ color: '#b0b3bb', fontSize: 12, marginTop: 8 }}>
          赠送套餐无 App 级配置，按赠送目标所属区域与服务类型生效；目标区域无法判定时按国内默认策略处理。
        </div>
      </BizSection>

      <BizSection title="App企业自收款 — 商务配置">
        {renderDefaultCards(selfConfig, selfComm, false)}
        <BizServiceOverrideTable overrides={selfConfig.services} fallback={selfConfig.default} />
      </BizSection>

      <BizSection title="App平台代收款 — 抽佣配置">
        {['cn', 'os'].map((region) => {
          const comm = platformComm?.[region] || {};
          return (
            <div key={region} style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', padding: '10px 20px', background: '#f7f8fa', borderRadius: 8, marginBottom: 8 }}>
              <Tag style={{ border: 'none', margin: 0 }}>{REGION_LABEL[region]}</Tag>
              {comm.isCommission ? (
                <>
                  <span style={{ color: '#409eff', fontWeight: 600 }}>抽佣 {Number(comm.commissionRate).toFixed(2)}%</span>
                  <span style={{ color: '#b0b3bb', fontSize: 12 }}>
                    抽佣时扣底价：{comm.isCommissionDeductBasePrice ? '扣除' : '不扣除'}
                  </span>
                </>
              ) : <span style={{ color: '#c0c4cc' }}>不抽佣</span>}
              {comm.remark && <span style={{ color: '#b0b3bb', fontSize: 12 }}>备注：{comm.remark}</span>}
            </div>
          );
        })}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 14px', background: '#f7f8fa', border: '1px dashed #e4e7ed', borderRadius: 8 }}>
          <span style={{ color: '#909399', fontSize: 13 }}>手续费</span>
          <BizStatus on={platformComm.isDeductPaymentFee} onText="扣除" offText="不扣除" />
          <span style={{ color: '#b0b3bb', fontSize: 12 }}>
            {platformComm.isDeductPaymentFee ? `${countConfiguredFees(platformComm.paymentFees)} 个支付方式已配置` : '按订单实付计算抽佣基数'}（不区分国内 / 海外）
          </span>
        </div>
        <div style={{ color: '#b0b3bb', fontSize: 12, marginTop: 8 }}>
          平台代收款不实时扣除底价，底价在抽佣出账时按「抽佣时扣底价」参与计算。
        </div>
      </BizSection>
    </div>
  );
};

// ══════════════════════════════════════════
//  未认证横幅
// ══════════════════════════════════════════

const UncertifiedBanner = () => (
  <Card size="small">
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '24px 32px', borderRadius: 8, background: '#e97a2b', color: '#fff' }}>
      <div>
        <div style={{ fontSize: 18, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
          完成企业认证，解锁平台全部权益！
          <Tag style={{ background: 'transparent', borderColor: '#fff', color: '#fff' }}>未认证</Tag>
        </div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginTop: 8 }}>认证后可享受平台采购折扣、套餐优惠、流量优惠、专属客服等服务</div>
      </div>
      <Button
        style={{ background: '#fff', color: '#e97a2b', border: 'none', fontWeight: 500 }}
        onClick={() => message.info('企业认证流程在原型中未实现，请参考真实平台')}
      >立即认证</Button>
    </div>
  </Card>
);

// ══════════════════════════════════════════
//  主组件：企业信息
// ══════════════════════════════════════════

const EnterpriseInfo = () => {
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [companyData, setCompanyData] = useState({});
  const [activeTab, setActiveTab] = useState('info');

  const loadCompanyData = () => {
    setLoading(true);
    // TODO: 联调时替换为接口数据
    setTimeout(() => {
      setCompanyData(MOCK_COMPANY_DATA);
      setLoading(false);
      setLoaded(true);
    }, 300);
  };

  useEffect(() => {
    loadCompanyData();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <Spin size="large" tip="加载企业信息..." />
      </div>
    );
  }

  const handleUpdate = (patch) => {
    setCompanyData(prev => ({ ...prev, ...patch }));
  };

  if (loaded && companyData.status) {
    return (
      <div>
        <div style={{ marginBottom: 16 }}>
          <StatusBanner status={companyData.status} registerTime={companyData.registerTime} />
        </div>
        <Card size="small">
          <Tabs activeKey={activeTab} onChange={setActiveTab} items={[
            {
              key: 'info',
              label: '企业信息',
              children: <CompanyInfoDetail companyData={companyData} onUpdate={handleUpdate} />
            },
            {
              key: 'business',
              label: '基础商务',
              children: <BusinessInfo companyData={companyData} />
            },
            {
              key: 'priceCommission',
              label: '底价与抽佣',
              children: <PriceCommissionInfo companyData={companyData} />
            },
            {
              key: 'adCommission',
              label: 'App广告抽佣',
              children: <AdCommissionBizSection apps={companyData.adCommissionApps || []} />
            }
          ]} />
        </Card>
      </div>
    );
  }

  return <UncertifiedBanner />;
};

export default EnterpriseInfo;
